function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.84 13.27l-1.46-.84a.506.506 0 010-.87l1.46-.84c.63-.36.84-1.17.48-1.8a1.32 1.32 0 00-1.8-.48l-1.46.84a.502.502 0 01-.75-.43V7.17c0-.72-.59-1.32-1.32-1.32-.73 0-1.32.59-1.32 1.32v1.68c0 .38-.42.63-.75.43l-1.46-.84a1.32 1.32 0 00-1.8.48c-.36.63-.15 1.44.48 1.8l1.46.84c.33.19.33.67 0 .87l-1.46.84a1.32 1.32 0 00-.48 1.8c.36.63 1.17.84 1.8.48l1.46-.84c.33-.19.75.05.75.43v1.68c0 .72.59 1.32 1.32 1.32.73 0 1.32-.59 1.32-1.32v-1.68c0-.38.42-.63.75-.43l1.46.84c.63.36 1.44.15 1.8-.48.37-.62.15-1.43-.48-1.8z"
})));